import React, { Fragment } from "react";
import { Col, Container, Row } from "reactstrap";
import WalletWrapper from './WalletWrapper';
import TermCard from './TermCard';
import MothriftLoader from '../../Common/MothriftLoader';

function CustomerDashboard({ transactionHook }) {
  const { userWalletInfo, userTerms, dataLoading } = transactionHook;

  if (dataLoading) return <MothriftLoader />;

  return (
    <Fragment>
      <Container fluid={true}>
        <Row className="widget-grid">
          <WalletWrapper userWalletInfo={userWalletInfo} hook={transactionHook} />
        </Row>
        <Row className="mt-4">
          {userTerms.length > 0 ? (
            userTerms.map((item, i) => (
              <Col xs={12} md={4} xxl={4} xl={6} key={i} className="mb-3">
                <TermCard data={item} />
              </Col>
            ))
          ) : (
            <Col xs={12}><TermCard data={null} /></Col>
          )}
        </Row>
      </Container>
    </Fragment>
  );
}

export default CustomerDashboard;